"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Odos = void 0;
const web3_candies_1 = require("@defi.org/web3-candies");
var Odos;
(function (Odos) {
    const URL = "https://api.odos.xyz";
    function findRoute(chainId, src, dst, amountIn, exchangeAdapter = web3_candies_1.zeroAddress, onlyDex, partner) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${URL}/sor/quote/v2`, {
                method: "POST",
                headers: { "Content-Type": "application/json", accept: "application/json" },
                body: JSON.stringify({
                    chainId,
                    inputTokens: [{ tokenAddress: src.address, amount: amountIn.toString() }],
                    outputTokens: [{ tokenAddress: dst.address, proportion: 1 }],
                    slippageLimitPercent: 50,
                    userAddr: exchangeAdapter,
                    sourceWhitelist: (onlyDex === null || onlyDex === void 0 ? void 0 : onlyDex.split(",")) || [],
                    simulate: false,
                    partner: partner || "",
                }),
            });
            if (response.status < 200 || response.status >= 400)
                throw new Error(`${response.statusText}`);
            const j = yield response.json();
            const srcUsd = (0, web3_candies_1.bn)(j.inValues[0]);
            const dstUsd = (0, web3_candies_1.bn)(j.outValues[0]);
            const dstAmount = (0, web3_candies_1.bn)(j.outAmounts[0]);
            const data = yield buildSwapData(j.pathId, dstAmount, exchangeAdapter);
            return {
                dstAmount,
                srcUsd,
                dstUsd,
                data,
                path: [],
            };
        });
    }
    Odos.findRoute = findRoute;
    function buildSwapData(pathId, dstAmountOut, exchangeAdapter) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${URL}/sor/assemble`, {
                method: "POST",
                headers: { accept: "application/json", "Content-Type": "application/json" },
                body: JSON.stringify({
                    pathId,
                    userAddr: exchangeAdapter,
                    simulate: false,
                }),
            });
            if (response.status < 200 || response.status >= 400)
                throw new Error(`${response.statusText}`);
            const swapData = (_b = (_a = ((yield response.json()))) === null || _a === void 0 ? void 0 : _a.transaction) === null || _b === void 0 ? void 0 : _b.data;
            if (!swapData)
                throw new Error(`invalid swap data from Odos`);
            return swapData;
        });
    }
})(Odos = exports.Odos || (exports.Odos = {}));
